<template>
  <a-row>
    <a-col :span="labelCol">
      <div class="label-title">{{title}}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-form-item v-bind="validate">
        <WangEditor ref="wangEditor" v-model:value="inputValue" @change="onChange" />
        <span v-if="validate" class="must">*</span>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref } from 'vue'
import WangEditor from '@/components/editor/WangEditor'

export default defineComponent({
  props: {
    value: {
      type: String
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 4
    },

    valueCol: {
      type: Number,
      default: 16
    },

    validate: {
      type: Object,
      default: () => null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'text'
    }
  },
  components: {
    WangEditor
  },
  emits: ['ok', 'update:value'],
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    const onChange = e => {
      emit('ok', e)
      emit('update:value', e)
    }

    return {
      inputValue,
      onChange
    }
  },

  methods: {
    setHtml (html) {
      this.$refs.wangEditor.setContent(html)
    }
  }
})
</script>

<style lang="less" scoped>
  .must{
    position: absolute;
    top: 3px;
    right: -10px;
    color: #f00;
    font-size: 18px;
    line-height: 32px;
  }
</style>
